import Helper from '@ember/component/helper';

import { service } from '@ember/service';

export default class LinkToDownloadTimeSeriesOutputsHelper extends Helper {
  @service('model/time-series-download') timeSeriesDownload;
  @service('model/time-series-download-all') timeSeriesDownloadAll;

  compute([ type, filename ], { disposition, id, isModeled, itemId, modelRunId }) {
    itemId = itemId || isModeled ? undefined : id;
    modelRunId = modelRunId || isModeled ? id : undefined;
    if (!(id || itemId || modelRunId)) {
      return this.timeSeriesDownloadAll.getUrl({ type, filename, disposition });
    }
    return this.timeSeriesDownload.getUrl({ itemId, modelRunId, type, filename, disposition });
  }
}
